import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "offcanvas offcanvas-bottom bg-primary-grasient h-auto",
  tabindex: "-1",
  id: "AudioPlayerModulOffcanvas",
  "aria-labelledby": "AudioPlayerModulOffcanvasLabel",
  ref: "AudioPlayerModulOffcanvas"
}
const _hoisted_2 = {
  class: "offcanvas-header d-flex align-items-center justify-content-between",
  style: {"padding-left":"48px","padding-right":"48px"}
}
const _hoisted_3 = { class: "offcanvas-title h2" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  class: "offcanvas-body text-white pb-5 pt-3",
  style: {"padding-left":"48px","padding-right":"48px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StandartAudioPlayerList = _resolveComponent("StandartAudioPlayerList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("audio.player")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-close text-reset collapse-hover",
          "data-bs-dismiss": "offcanvas",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('hide')))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_StandartAudioPlayerList)
    ])
  ], 512))
}